/**
* @ngdoc component
* @name help.component:itxHelpPage
* @requires common.service:cmsService
* @description
* Main Help Page component.
* This component renders the main structure of the page.
*/
(function() {
    'use strict';

    var itxHelpPage = {
        controllerAs: '$ctrl',
        controller:   itxHelpPageCtrl,
        templateUrl: 'help-page.component.html'
    };

    itxHelpPageCtrl.$inject = [];

    function itxHelpPageCtrl () {
        
        this.$onInit = function () {
        };
    }

    angular.module('itxApp.help')
    .component('itxHelpPage',itxHelpPage);

})();